export default __webpack_public_path__ + "static/media/van.a5e2abd9.svg";